
import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./components/Layout/MainLayout";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
// Import NotFound directly to avoid dynamic import issues in error boundaries
import NotFound from "./pages/NotFound";

// Import Uppdrag directly to avoid React duplication issues
import Uppdrag from "./pages/Uppdrag";

// Lazy-loaded pages for better code-splitting
const Riskbedomning = lazy(() => import("./pages/Riskbedomning"));
const Auth = lazy(() => import("./pages/Auth"));
const Profile = lazy(() => import("./pages/Profile"));
const Home = lazy(() => import("./pages/Home"));
const Chat = lazy(() => import("./pages/Chat"));
const ChatHelper = lazy(() => import("./pages/ChatHelper"));
const EditProjectPage = lazy(() => import("./pages/EditProject"));
const DocumentSettingsPage = lazy(() => import("./pages/DocumentSettings"));
const TranslationSettings = lazy(() => import("./pages/TranslationSettings"));
const EgenkontrollPage = lazy(() => import("./pages/Egenkontroll"));
const SKRBedomningContainer = lazy(() => import("./pages/SKRBedomningContainer"));
const WorkPreparationPage = lazy(() => import("./pages/WorkPreparationPage"));
const Admin = lazy(() => import("./pages/Admin"));

// Define your routes - consolidated to use only UppdragPage system
export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout><Home /></MainLayout>,
  },
  {
    path: "/profile",
    element: <MainLayout><Profile /></MainLayout>,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/riskbedomning",
    element: <MainLayout><Riskbedomning /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/uppdrag",
    element: <MainLayout><Uppdrag /></MainLayout>,
  },
  {
    path: "/uppdrag/:projektId",
    element: <MainLayout><Uppdrag /></MainLayout>,
  },
  {
    path: "/uppdrag/:projektId/:folderId",
    element: <MainLayout><Uppdrag /></MainLayout>,
  },
  {
    path: "/uppdrag/shared/:folderId",
    element: <MainLayout><Uppdrag /></MainLayout>,
  },
  {
    path: "/chat",
    element: <MainLayout><Chat /></MainLayout>,
  },
  {
    path: "/chat-hjalpen",
    element: <ProtectedRoute><MainLayout><ChatHelper /></MainLayout></ProtectedRoute>,
  },
  {
    path: "/document-settings",
    element: <MainLayout><DocumentSettingsPage /></MainLayout>,
  },
  {
    path: "/edit-project/:projectId",
    element: <MainLayout><EditProjectPage /></MainLayout>,
  },
  {
    path: "/translation-settings",
    element: <MainLayout><TranslationSettings /></MainLayout>,
  },
  {
    path: "/egenkontroll",
    element: <MainLayout><EgenkontrollPage /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/skr-bedomning",
    element: <MainLayout><SKRBedomningContainer /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/skr-bedomning/:projektId/:folderId",
    element: <MainLayout><SKRBedomningContainer /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/arbetsberedning/:projektId/:folderId",
    element: <MainLayout><WorkPreparationPage /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/arbetsberedning/:projektId/:folderId/:workPreparationId",
    element: <MainLayout><WorkPreparationPage /></MainLayout>,
    errorElement: <MainLayout><NotFound /></MainLayout>,
  },
  {
    path: "/admin",
    element: <MainLayout><Admin /></MainLayout>,
  },
  {
    path: "*",
    element: <MainLayout><NotFound /></MainLayout>,
  }
]);
